import { Stack } from "@mui/material";
import type { MerchantFeeDto, ProductCode } from "Infrastructure/Api/Api";
import { toast } from "sonner";
import { Resources, useResource } from "Translations/Resources";
import { useUpdateMerchantFees } from "Api/Mutations/Merchants/useUpdateMerchantFees";
import type { ProductPricingVariants } from "Components/Hunter/Merchants/types";
import { RadioButtons } from "Components/Shared/Inputs/RadioButtons";
import { useProductPricingFeesList } from "Hooks/Options/useProductPricingFeesList";

const RESOURCES = Resources.Components.Merchant.Pricings;

type FeeUpdateFormProps = {
  value: string;
  merchantPublicID: string;
  productCode: ProductCode;
  currentFees: Array<MerchantFeeDto>;
  pricings: Array<ProductPricingVariants>;
};

export const ProductFeeUpdateForm = ({
  value,
  pricings,
  currentFees,
  productCode,
  merchantPublicID,
}: FeeUpdateFormProps) => {
  const { t } = useResource();

  const feesCodeList = useProductPricingFeesList(pricings, productCode);

  const { mutate: updateFees } = useUpdateMerchantFees({
    onError: () => toast.error(t(RESOURCES.PricingChangeError)),
  });

  const handleChange = (value: string) => {
    const currentFeeId = currentFees.find(
      (fee) => fee.productCode === productCode,
    )?.publicID;

    if (currentFeeId) {
      updateFees({
        publicID: merchantPublicID,
        data: {
          publicID: currentFeeId,
          productCode,
          merchantPricingID: Number(value),
        },
      });
    }
  };

  return (
    <Stack component="label" mt={1}>
      {t(RESOURCES.SelectPricingLabel)}
      <RadioButtons
        value={value}
        onChange={handleChange}
        codeList={feesCodeList}
      />
    </Stack>
  );
};
